import React from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';

interface TextFieldProps {
    id: string;
    /** Lowercase label with explicit requiredness, e.g. 'name (required):'. */
    label: string;
    registration: UseFormRegisterReturn;
    error?: string;
    type?: string;
    as?: 'input' | 'textarea';
    rows?: number;
}

// Reusable RHF-wired field (label + control + error). Errors are grayscale (message +
// aria-invalid + darker border), not colour alone, keeping the chrome monochrome.
export const TextField = ({ id, label, registration, error, type = 'text', as = 'input', rows = 5 }: TextFieldProps) => {
    const errorId = `${id}-error`;
    const controlClass = `mt-1 w-full border ${error ? 'border-ink' : 'border-tone-200'} bg-canvas px-2 py-1 text-meta text-ink focus:border-ink`;
    const shared = {
        id,
        ...registration,
        'aria-invalid': error ? true : undefined,
        'aria-describedby': error ? errorId : undefined,
        className: controlClass,
    };

    return (
        <div>
            <label htmlFor={id} className="text-meta text-tone-900">
                {label}
            </label>
            {as === 'textarea' ? <textarea {...shared} rows={rows} /> : <input {...shared} type={type} />}
            {error && (
                <p id={errorId} role="alert" className="mt-1 text-caption italic text-ink">
                    {error}
                </p>
            )}
        </div>
    );
};
